import { render, staticRenderFns } from "./TeamSelectNew.vue?vue&type=template&id=002051f1&scoped=true"
import script from "./TeamSelectNew.vue?vue&type=script&lang=js"
export * from "./TeamSelectNew.vue?vue&type=script&lang=js"
import style0 from "./TeamSelectNew.vue?vue&type=style&index=0&id=002051f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002051f1",
  null
  
)

export default component.exports